<template>
  <div>
    <section role="form">
      <div class="main-container container container-top">
        <div class="row">
          <div class="col-md-12">
            <div v-for="autenticado in autenticados" :key="autenticado.id">
              <div class="card card-default">
                <div class="card-content">
                  <h4>
                    Meus Dados
                    <span v-if="autenticados.length > 1"
                      >- {{ autenticado.registroFormatado }}</span
                    >
                  </h4>
                  <div class="row">
                    <div class="form-group col-lg-6 col-md-6 col-sm-6">
                      <label>Nome:</label>
                      <p>{{ usuarioLogado.nome }}</p>
                    </div>
                    <div class="form-group col-lg-3 col-md-3 col-sm-3">
                      <label>Registro:</label>
                      <p>{{ autenticado.registroFormatado }}</p>
                    </div>
                    <div class="form-group col-lg-3 col-md-3 col-sm-3">
                      <label>Cargo:</label>
                      <p>{{ autenticado.cargoPrincipal }}</p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-lg-6 col-md-6 col-sm-6">
                      <label>Unidade Organizacional:</label>
                      <p>
                        {{
                          `${autenticado.siglaUnidadeOrganizacional} - ${autenticado.unidadeOrganizacional}`
                        }}
                      </p>
                    </div>
                    <div class="form-group col-lg-3 col-md-3 col-sm-3">
                      <label>Início das atividades:</label>
                      <p>{{ autenticado.dataInicioAtividade | formataData }}</p>
                    </div>
                    <div class="form-group col-lg-3 col-md-3 col-sm-3">
                      <label>Centro de Custo:</label>
                      <p>{{ autenticado.centroCustoFormatado }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Conta',

  data() {
    return {
      usuarioLogado: this.$store.state.usuarioLogado,
      autenticados: this.$store.state.usuarioLogado.funcionarios,
    };
  },

  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>



// WEBPACK FOOTER //
// index.vue?e89b0f64